





































import { defineComponent, PropType, toRefs, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  AcoFormData,
  ACTION_TYPE,
  NormalCreative,
} from '@tt4b/ttam-enums';
import { useCreativeCtaValidate, useStore, StateEnum } from '@tt4b/ttam-hooks';
import { get } from 'lodash-es';
import CreativeCtaSelect from './select/index.vue';
import CreativeCtaLabel from './label/index.vue';
import CreativeCta from './index';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-creative-cta-normal-compose';

export default defineComponent({
  name,
  components: {
    CreativeCtaSelect,
    CreativeCtaLabel,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: () => ACTION_TYPE.CREATE,
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    isDisabledCreative: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, isDisabledCreative, createMode, normalCreativeData } =
      toRefs(props);

    const { options } = CreativeCta.useSelectPropsOptions({
      adgroupData,
      campaignData,
      creativeData,
    });

    const _callToAction = computed({
      get: () => creativeData.value?.callToAction || '',
      set: (val: string) => {
        emit('change', val);
        emit('input', val);
      },
    });

    const { ctaValidator } = useCreativeCtaValidate();

    const { visible: linkVisible } = CreativeCta.useLabelHintPropsLinkVisible({
      campaignData,
      adgroupData,
      normalCreativeData,
      createMode,
    });

    const { disabled: disbaledSelect } = CreativeCta.useSelectPropsDisabled({
      creativeData,
      isDisabledCreative,
    });

    // 数据埋点
    function setTeaEvent(type, value) {
      trackEvent(type, {
        action_type: createMode.value,
        external_type: String(adgroupData.value?.externalType),
        cta_value: value,
      });
    }

    const { getStore } = useStore();
    const { data } = getStore(
      StateEnum.recommendCtaList,
      { assetType: 0, externalType: adgroupData.value?.externalType },
      false,
    );
    const recommendCta = computed(() => get(data.value, '[0].assetContent') ?? '');

    return {
      name,
      options,
      disbaledSelect,
      _callToAction,
      ctaValidator,
      recommendCta,
      linkVisible,
      setTeaEvent,
    };
  },
});
